export default "__VITE_ASSET__C0b8fLo5__"